/** Отношение учётной записи к группе */
export enum EnumGroupRole {
  OWNER = 'owner',
  MEMBER = 'member',
  APPLICANT = 'applicant',
}
